import { atom } from 'recoil';

export const documentInViewState = atom({
  key: "documentInViewState",
  default: {}
});
